//libs
import { styled } from '@nykaa/ui-components';
//contants
import { COLORS, FOCUS_VISIBILITY_CSS } from 'shared/styles/base';
//components
import ImageV2 from 'shared/components/ImageV2';
import Svgs from 'shared/components/MyAccount/Svgs';

export const StyledFooter = styled.div`
  background: ${COLORS.BLACK_96};
  width: 100%;
  display: flex;
  background-color: black;
  flex-wrap: wrap;
`;

export const SvgContainer = styled(Svgs)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const IconContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${COLORS.DARK_GRAY};
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: ${({ theme }) => theme.borders.radius50}; //chose floor value
  margin: 0;

  .shipping-icon {
    position: relative;
    left: 3px;
    top: 5px;
  }
`;
export const FooterIconContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 25%;
  margin-bottom: ${({ theme }) => theme.spacing.spacing100};
  text-align: center;

  ${FOCUS_VISIBILITY_CSS}

  &:focus-visible {
    outline-color: ${({ theme }) => theme.colors.secondary};
  }
`;

export const FooterText = styled.p`
  color: ${({ theme }) => theme.colors.textInversePrimary};
  text-align: center;
  ${({ theme }) => theme.typography.type120};
  max-width: 72px;
  margin: ${({ theme }) => `${theme.spacing.spacing50} 0`}; ;
`;

export const ImageContainer = styled(ImageV2)`
  width: 36px;
`;
